import { styled } from "@mui/material/styles";

export const StyledCompleteButtonContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  marginTop: "40px",
  justifyContent: "flex-end"
}));
